import React from 'react';
import { CompanySwitcher } from '@/components/ui/company-switcher';
import { GlobalSearch } from '@/components/ui/global-search';
import { SecurityStatusBadge } from '@/components/ui/security-status-badge';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { NotificationCenter } from '@/components/NotificationCenter';
import { ThemeToggle } from '@/components/ThemeToggle';
import { UIDensityToggle } from '@/components/UIDensityToggle';

import { useAuth } from '@/hooks/useAuth';
import { useMobileView } from '@/hooks/useMobileDetection';

export const Header: React.FC = () => {
  const { user } = useAuth();
  const { shouldUseMobileView } = useMobileView();

  if (!user) return null;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border/20 bg-background/80 backdrop-blur-xl supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-12 sm:h-14 items-center px-3 sm:px-4 lg:px-6">
        {/* Left Section - Navigation */}
        <div className="flex items-center space-x-2 sm:space-x-4 min-w-0 flex-1 sm:flex-initial">
          {!shouldUseMobileView && (
            <SidebarTrigger className="flex-shrink-0" />
          )}
          
          {/* Company Context - Simplified */}
          <div className="flex-shrink-0 min-w-0 max-w-[200px] sm:max-w-none">
            <CompanySwitcher compact={shouldUseMobileView} />
          </div>
        </div>

        {/* Center Section - Search (Desktop only) */}
        {!shouldUseMobileView && (
          <div className="flex-1 max-w-sm lg:max-w-xl mx-4 lg:mx-8">
            <GlobalSearch />
          </div>
        )}

        {/* Right Section - Actions */}
        <div className="flex items-center space-x-2 sm:space-x-3 ml-auto flex-shrink-0">
          {/* Security & System Status */}
          <SecurityStatusBadge />
          
          {/* Quick Actions */}
          {!shouldUseMobileView && (
            <>
              <div className="h-4 sm:h-5 w-px bg-border/50" />
              <NotificationCenter />
              <UIDensityToggle />
              <ThemeToggle />
            </>
          )}
        </div>
      </div>
    </header>
  );
};